/**
 * La fase, dicha para quien mira la consola (spec 063 · FR-003).
 * El token del diario no se imprime.
 */
const FRASE: Record<string, string> = {
    umbral: 'Pidiendo consentimiento',
    conversando: 'Gestionando la cita',
    confirmando: 'Confirmando la cita',
    escalada: 'Pasando a un humano',
    cerrada: 'Terminó',
}

export function fraseDeFase(fase: string | null | undefined): string {
    if (!fase) return 'En curso'
    return FRASE[fase] ?? 'En curso'
}
